// **Third party Imports
import { Helmet } from 'react-helmet'

const SEOComponent = (props) => {
  // destructuring
  const { title, scripts } = props

  return (
    <Helmet>
      <title> {title || 'CoderScout'} </title>
      <meta property="og:title" content={title || 'CoderScout'} />
      <meta property="og:url" content={window.location.href} />
      <meta name="twitter:title" content={title || 'CoderScout'} />
      <meta name="twitter:card" content="summary_large_image" />
      {scripts && scripts()}
    </Helmet>
  )
}

export default SEOComponent
